import { render, staticRenderFns } from "./RulesCard.vue?vue&type=template&id=6aa66553&"
import script from "./RulesCard.vue?vue&type=script&lang=js&"
export * from "./RulesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports